/* eslint-disable */
function distinct(arr) {
  return [...new Set(arr)]
}

export function isAuthorized(authDataDTO, departmentId, moduleCode, permission) {
  if (authDataDTO == null || authDataDTO.deptRoles == null) {
    return false;
  }
  const roleIdList = distinct(authDataDTO.deptRoles
    .filter(dr => departmentId == null || departmentId == dr.deptId)
    .map(dr => dr.roleId));

  for (let roleId of roleIdList) {
    if (!authDataDTO.roles[String(roleId)]) {
      continue;
    }
    if (!authDataDTO.roles[String(roleId)][moduleCode]) {
      continue;
    }
    if (authDataDTO.roles[String(roleId)][moduleCode].indexOf(permission) >= 0) {
      return true;
    }
  }
  return false;
}

export function isAdminAuthorized(authDataDTO, departmentId, moduleCode, permission) {
  if (authDataDTO == null || !authDataDTO) {
    return false;
  }

  const roleIdList = distinct(
    authDataDTO[moduleCode]
      .map(dr => dr));

  if (roleIdList.includes(permission)) {
    return true
  } else {
    return false
  }
}
